module.exports = __webpack_public_path__ + "img/map-de.103d699e.png";